import styled from "styled-components";
import colors from "css/colors";

export const InputWrapper = styled.div`
  display: flex;

  .ant-input {
    border-color: ${colors.GREY_LIGHT};
    border-radius: 6px;
  }

  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border-color: ${colors.GREY_LIGHT};
    border-radius: 6px;
    padding: 10px;
    overflow: hidden;
  }

  .ant-select-multiple .ant-select-selection-placeholder {
    margin-left: 7px;
  }
`;

export const SelectWrapper = styled.div`
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border-color: ${colors.GREY_LIGHT};
    border-radius: 6px;
    overflow: hidden;
  }

  .ant-select {
    width: 100%;
  }
`;
